<template>
  <v-container fluid>
    <router-view />
  </v-container>
</template>

<script>
export default {
  name: "StatisticsLayout",
};
</script>

<style scoped></style>
